// Точка входа скриптов сайта зимней школы → /school-assets/app.min.js
import { HeaderMenu } from "../Header/Header.js"
import { initSnow } from "../Snow/Snow.js"
import { Popup } from "../Popup/Popup.js"
import { initReveal } from "./reveal.js"
import { Program } from "../Program/Program.js"
import { ProgramClass } from "../Program-class/Program-class.js"
import { Tooltip } from "../Tooltip/Tooltip.js"

// App heights: --app-height (высота экрана), --header-height (высота шапки)
const doc = document.documentElement
const appHeights = () => {
	doc.style.setProperty('--app-height', window.innerHeight + 'px')
	const header = document.querySelector('.header')
	if (header) doc.style.setProperty('--header-height', header.offsetHeight + 'px')
}
appHeights()
window.addEventListener('resize', appHeights)

document.addEventListener('DOMContentLoaded', () => {
	appHeights()
	new HeaderMenu()
	new Tooltip()
	const popup = new Popup()
	new Program()
	new ProgramClass(popup)
	initReveal()
	initSnow()
})
